import Excuses from "./Excuses";

export default Excuses;
